import NotesMobile from './NotesMobile';

export default NotesMobile;
export { NotesMobile };
